import debounce = require('lodash.debounce');
import React = require('react');

export interface IError {
    extensions?: { exception: any };
    message: string;
}

export type Suggestion = any;

export interface IFetchResponse {
  error?: string;
  requestId: number;
  suggestions: Suggestion[];
}

export type FetchSuggestionsFunc = (it: string, requestId: number) => Promise<IFetchResponse>;

interface IFetchSuggestionsProps {
    children?: any;
    debounceInterval?: number;
    fetchSuggestions: FetchSuggestionsFunc;
    minLength?: number;
    searchValue: string;
    selectedItem?: any;
}

interface IFetchSuggestionsState {
    error: string;
    loading: boolean;
    requestId: number;
    suggestions: Suggestion[];
}

export const handleSuggestionError = (requestId: number, errors: IError[] = []): Promise<IFetchResponse> => {
    const error = errors.map((e) => e.message).join(' ');

    return Promise.reject({
        error,
        requestId,
        suggestions: []
    });
};

export class FetchSuggestions extends React.Component<IFetchSuggestionsProps, IFetchSuggestionsState> {
    public static defaultProps = {
        debounceInterval: 300,
        minLength: 3,
    };

    private static initialState = {
        error: '',
        loading: false,
        requestId: 0,
        suggestions: [],
    };

    public state = FetchSuggestions.initialState;

    private fetch = debounce(() => {
        this.state.requestId++;

        this.props.fetchSuggestions(this.props.searchValue, this.state.requestId)
        .then(({suggestions, requestId}) => {
            if (requestId === this.state.requestId) {
                this.setState({ loading: false, suggestions}, () => {
                    window.dispatchEvent(new Event('resize')); // force popper to re-evaluate position
                });
            }
        },
        ({error, requestId}) => {
            if (requestId === this.state.requestId) {
                this.setState({ loading: false, error, suggestions: [] });
            }
        });
      },
      this.props.debounceInterval
    );

    constructor(props: IFetchSuggestionsProps) {
        super(props);
    }

    public componentDidMount() {
        this.executeFetch();
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.searchValue !== this.props.searchValue) {
            this.executeFetch();
        }
    }

    public render() {
        return this.props.children(this.state);
    }

    private reset(overrides) {
        this.setState({...FetchSuggestions.initialState, ...overrides});
    }

    private prepareFetch() {
        this.reset({ loading: true });
    }

    private executeFetch = () => {
        if (this.props.searchValue.length >= this.props.minLength) {
            this.prepareFetch();
            this.fetch();
        }
    }
}

export default FetchSuggestions;
